/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_EditInputs */

const vi_fertilizer_edit = /** @type {(inputs: Fertilizer_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa phân bón`)
};

/**

* @param {Fertilizer_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_edit = /** @type {((inputs?: Fertilizer_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_edit(inputs)
});